import axios from 'axios'
import store from '@/store'
import { message } from 'ant-design-vue'
import md5 from 'crypto-js/md5'
import { getSecretKey } from './secret'

export const signRequest = (config) => {
  const sk = getSecretKey()
  if (!sk) return config
  const ts = config.headers['X-Timestamp']
  const nonce = config.headers['X-Nonce']
  const method = (config.method || '').toLowerCase()
  const isFormData = config.data instanceof FormData
  const body = isFormData ? '' : (method === 'get' ? '' : (config.data ? (typeof config.data === 'string' ? config.data : JSON.stringify(config.data)) : ''))
  config.headers['X-Sign'] = md5(body + ts + nonce + sk).toString()
  return config
}

// 全局错误提示防抖
let errorTimer = null
const ERROR_DEBOUNCE_MS = 1000 // 1秒内不重复提示错误

const showErrorMessage = (msg) => {
  if (errorTimer) return // 如果已有定时器，说明刚显示过错误，不再显示
  message.error(msg)
  errorTimer = setTimeout(() => {
    errorTimer = null
  }, ERROR_DEBOUNCE_MS)
}

export { showErrorMessage }

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api', // 使用 Nginx 反向代理
  timeout: 300000, // 单位是毫秒，300000=5分钟
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {

    // 在发送请求之前做些什么
    const token = store.getters.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      config.headers['X-Timestamp'] = Math.floor(Date.now() / 1000) //秒时间戳
      config.headers['X-Nonce'] = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15) //随机guid
      config.headers['X-Device-Id'] = generateMoreUniqueDeviceId() //设备唯一码
      signRequest(config)
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    const res = response.data

    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    if (response.status === 200) {
      // 直接返回响应数据，让业务层处理 success 字段
      return res
    } else {
      // 否则的话抛出错误
      showErrorMessage(res.message || '请求失败')
      // return Promise.reject(new Error(res.message || '请求失败'))
    }
  },
  error => {
    // 对响应错误做点什么
    console.error('响应错误:', error)

    if (error.response) {
      const { status, data } = error.response

      switch (status) {
        case 401:
          showErrorMessage('登录已过期，请重新登录')
          store.dispatch('logout')
          window.location.href = '/login'
          break
        case 403:
          showErrorMessage('没有权限访问该资源')
          break
        case 404:
          showErrorMessage('请求的资源不存在')
          break
        case 500:
          showErrorMessage('服务器内部错误')
          break
        default:
          showErrorMessage(data?.message || '请求失败')
      }
    } else if (error.code === 'ECONNABORTED') {
      showErrorMessage('请求超时，请检查网络连接')
    } else {
      showErrorMessage('网络错误，请检查网络连接')
    }

    return Promise.reject(error)
  }
)

/**
 * 生成设备唯一码
 * @returns 设备唯一码
 */
function generateMoreUniqueDeviceId() {

  //获取设备唯一码
  let deviceId = localStorage.getItem('deviceId')

  if (deviceId != "" && deviceId != null) {
    return deviceId
  }

  // 1. 时间戳（精确到毫秒，确保不同时间生成的ID不同）
  const timestamp = new Date().getTime().toString(16);

  // 2. 随机数（16位）
  const random = Math.random().toString(16).substr(2, 16);

  // 3. 浏览器指纹（简单提取，如浏览器类型+屏幕分辨率）
  const fingerprint = `${navigator.userAgent.substring(0, 10)}_${screen.width}x${screen.height}`;
  const fingerprintHash = btoa(fingerprint).substr(0, 8); // 简单编码成8位

  // 拼接成UUID风格的字符串
  deviceId = `${timestamp}-${random.substr(0, 4)}-4${random.substr(4, 3)}-${random.substr(7, 4)}-${fingerprintHash}${random.substr(11, 12)}`;

  //存token到本地
  localStorage.setItem('deviceId', deviceId)
  return deviceId
}

export default service